import { render, staticRenderFns } from "./ProductosView.vue?vue&type=template&id=4fe63740&"
import script from "./ProductosView.vue?vue&type=script&lang=js&"
export * from "./ProductosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports